/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_TitleInputs */

const cs_tasks_protocol_title = /** @type {(inputs: Tasks_Protocol_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol o prohlídce`)
};

const en_tasks_protocol_title = /** @type {(inputs: Tasks_Protocol_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewing protocol`)
};

/**
* | output |
* | --- |
* | "Viewing protocol" |
*
* @param {Tasks_Protocol_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_title = /** @type {((inputs?: Tasks_Protocol_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_title(inputs)
	return cs_tasks_protocol_title(inputs)
});